import React from 'react';
import { trackLeadEvent, getTrackingUrl } from '../utils/trackingUtils';
export function CheckAvailabilityButton() {
  const handleClick = () => {
    trackLeadEvent();
  };
  const targetUrl = getTrackingUrl('https://nivieorganics.com/pages/mineral-drops');
  return <a href={targetUrl} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="inline-block bg-black text-white px-8 py-3 rounded-lg font-bold text-lg tracking-wide hover:bg-gray-800 transition-colors" data-id="element-246">
      CHECK AVAILABILITY
    </a>;
}